module.exports = __webpack_public_path__ + "img/Delivery.84cd785b.svg";